import {
  Box,
  Button,
  Card,
  CardActionArea,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { PRESETS } from "../presets";

const PRESET_CONFIGS = [
  {
    key: "blank",
    titleKey: "blank",
    descKey: "blankDesc",
    preview: null,
  },
  {
    key: "breaking-news",
    titleKey: "breakingNews",
    descKey: "breakingNewsDesc",
    preview: [
      { top: "90%", left: 0, width: "100%", height: "8%", bg: "#cc0000" },
    ],
  },
  {
    key: "lower-third",
    titleKey: "lowerThird",
    descKey: "lowerThirdDesc",
    preview: [
      { top: "78%", left: "5%", width: "2%", height: "12%", bg: "#ff5722" },
      { top: "79%", left: "9%", width: "55%", height: "5%", bg: "#ffffff40" },
      { top: "86%", left: "9%", width: "40%", height: "4%", bg: "#ffffff25" },
    ],
  },
  {
    key: "watermark",
    titleKey: "watermark",
    descKey: "watermarkDesc",
    preview: [
      { top: "3%", left: "76%", width: "18%", height: "10%", bg: "#888888" },
      { top: "14%", left: "70%", width: "26%", height: "3%", bg: "#ffffff30" },
    ],
  },
];

function PresetPreview({ config }) {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        paddingTop: "56%",
        borderRadius: 1,
        overflow: "hidden",
        bgcolor: "#1a1a1a",
        mb: 1,
      }}
    >
      {(config.preview || []).map((rect, i) => (
        <Box
          key={i}
          sx={{
            position: "absolute",
            top: rect.top,
            left: rect.left,
            width: rect.width,
            height: rect.height,
            background: rect.bg,
            borderRadius: "1px",
          }}
        />
      ))}
    </Box>
  );
}

export default function PresetsDialog({ open, onClose, onSelect, t }) {
  const tp = (t.presets || {});
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{tp.title || "Choose a starting point"}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          {PRESET_CONFIGS.map((cfg) => (
            <Grid item xs={6} key={cfg.key}>
              <Card variant="outlined" sx={{ height: "100%" }}>
                <CardActionArea
                  onClick={() => onSelect(cfg.key, PRESETS[cfg.key])}
                  sx={{ p: 1.5, height: "100%", display: "flex", flexDirection: "column", alignItems: "flex-start" }}
                >
                  <PresetPreview config={cfg} />
                  <Typography variant="body2" fontWeight={600}>
                    {tp[cfg.titleKey] || cfg.key}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {tp[cfg.descKey] || ""}
                  </Typography>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
        <Box sx={{ mt: 2, textAlign: "center" }}>
          <Button size="small" color="inherit" onClick={() => onSelect("blank", [])}>
            {tp.skip || "Skip — start from blank"}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
